<div class="branding-step">
  <h2 class="step-title">Brand Your Organization</h2>
  <p class="step-subtitle">Choose a theme color and upload your logo for the donation kiosk and receipts. You can change these later in your console.</p>

  <!-- Theme Color -->
  <section class="section">
    <h3 class="section-title">Primary Color</h3>
    <div class="color-palette">
      <button
        *ngFor="let color of themeColors"
        class="color-swatch"
        [class.selected]="selectedColor === color.hex"
        [style.background-color]="color.hex"
        [title]="color.name"
        (click)="selectColor(color.hex)"
        type="button">
        <mat-icon *ngIf="selectedColor === color.hex" class="check-icon">check</mat-icon>
      </button>
    </div>
    <p class="color-preview-label">Selected: <span [style.color]="selectedColor" style="font-weight:600">{{ selectedColor }}</span></p>
  </section>

  <!-- Logo Upload -->
  <section class="section">
    <h3 class="section-title">Organization Logo</h3>
    <p class="hint">Shown on the kiosk screen, receipts, and donor emails. PNG or JPG, max 5 MB.</p>

    <div class="upload-area" *ngIf="!logoPreviewUrl && !logoUploading">
      <label class="upload-label" for="logo-input">
        <mat-icon>upload</mat-icon>
        <span>Choose logo file</span>
      </label>
      <input id="logo-input" type="file" accept="image/*" (change)="onLogoSelected($event)" style="display:none">
    </div>

    <div *ngIf="logoUploading" class="upload-progress">
      <p>Uploading… {{ logoProgress }}%</p>
      <mat-progress-bar mode="determinate" [value]="logoProgress"></mat-progress-bar>
    </div>

    <div *ngIf="logoPreviewUrl" class="preview-container">
      <img [src]="logoPreviewUrl" alt="Logo preview" class="logo-preview">
      <label for="logo-input-replace">
        <button mat-stroked-button type="button" (click)="logoInput.click()">Replace</button>
      </label>
      <input #logoInput type="file" accept="image/*" (change)="onLogoSelected($event)" style="display:none">
    </div>
  </section>

  <!-- Kiosk Background -->
  <section class="section">
    <h3 class="section-title">Kiosk Background Image <span class="optional">(optional)</span></h3>
    <p class="hint">Displayed behind the donation screen on your kiosk tablets. Landscape, min 1920×1080 recommended, max 5 MB.</p>

    <div class="upload-area" *ngIf="!bgPreviewUrl && !bgUploading">
      <label class="upload-label" for="bg-input">
        <mat-icon>upload</mat-icon>
        <span>Choose background image</span>
      </label>
      <input id="bg-input" type="file" accept="image/*" (change)="onBackgroundSelected($event)" style="display:none">
    </div>

    <div *ngIf="bgUploading" class="upload-progress">
      <p>Uploading… {{ bgProgress }}%</p>
      <mat-progress-bar mode="determinate" [value]="bgProgress"></mat-progress-bar>
    </div>

    <div *ngIf="bgPreviewUrl" class="preview-container">
      <img [src]="bgPreviewUrl" alt="Background preview" class="bg-preview">
      <input #bgInput type="file" accept="image/*" (change)="onBackgroundSelected($event)" style="display:none">
      <button mat-stroked-button type="button" (click)="bgInput.click()">Replace</button>
    </div>
  </section>

  <!-- Actions -->
  <div class="actions">
    <button mat-button type="button" (click)="skip()" [disabled]="saving || logoUploading || bgUploading">
      Skip for now
    </button>
    <button mat-flat-button color="primary" type="button"
      (click)="save()"
      [disabled]="saving || logoUploading || bgUploading">
      <span *ngIf="!saving">Save & Continue</span>
      <span *ngIf="saving">Saving…</span>
    </button>
  </div>
</div>
